import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { colors } from '@joykit/variables';
import { styled, Text, Stack, Link } from '@withjoy/joykit';

export namespace styles {
  export const text = css({
    ...getInterUIDynamicMetricCssObject(15),
    color: '#bfbfbf',
    fontWeight: 500,
    marginBottom: 16
  });

  export const form = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: '40px !important',
    '>:nth-child(2)': {
      marginBottom: 0
    }
  });

  export const authButton = css({
    ...getInterUIDynamicMetricCssObject(16)
  });

  export const formError = css({
    padding: 0,
    margin: '1rem 0',
    ...getInterUIDynamicMetricCssObject(13),
    color: colors.bad
  });
}

export const EnhancedStack = styled(Stack)`
  width: 100%;
  align-items: center;
  margin-bottom: 10rem;

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    width: 22rem;
  }
`;

export const InputStack = styled(Stack)`
  width: 100%;
`;

export const HelpText = styled(Text)`
  margin-bottom: 40px !important;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.action};
`;
